/**
 * Acompte (Salary Advance Request) Types for HR Module
 */

export type StatutAcompte = 'EN_ATTENTE' | 'VALIDEE' | 'REFUSEE' | 'PAYEE';

export interface EmployeeInfo {
  id: number;
  matricule: string;
  nom_complet: string;
  fonction: string | null;
  date_embauche: string | null;
  cin: string | null;
  adresse: string | null;
  nom_complet_ar?: string | null;
  adresse_ar?: string | null;
}

export interface ValidatorInfo {
  id: number;
  email: string;
  name: string | null;
}

export interface Acompte {
  id: number;
  ref_acompte: string | null;
  employee_id: number;
  employee: EmployeeInfo | null;
  montant: number;
  date_demande: string;
  date_paiement: string | null;
  motif: string | null;
  statut: StatutAcompte;
  validated_by: number | null;
  validator: ValidatorInfo | null;
  validated_at: string | null;
  commentaire: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface AcompteCreate {
  employee_id: number;
  montant: number;
  date_demande: string;
  motif?: string | null;
}

export interface AcompteUpdate {
  montant?: number;
  date_demande?: string;
  motif?: string | null;
}

export interface AcompteValidate {
  statut: StatutAcompte;
  commentaire?: string | null;
  date_paiement?: string | null;
}

export interface AcompteMarkPaid {
  date_paiement?: string | null;
}

export interface AcompteListResponse {
  items: Acompte[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface AcompteStats {
  total_demandes: number;
  total_en_attente: number;
  total_validees: number;
  total_payees: number;
  total_refusees: number;
  total_montant_valide: number;
  total_montant_paye: number;
}

// Constants for dropdowns
export const STATUT_ACOMPTE_OPTIONS: { value: StatutAcompte; label: string; color: string }[] = [
  { value: 'EN_ATTENTE', label: 'En attente', color: 'warning' },
  { value: 'VALIDEE', label: 'Validee', color: 'info' },
  { value: 'PAYEE', label: 'Payee', color: 'success' },
  { value: 'REFUSEE', label: 'Refusee', color: 'error' },
];

export const getStatutAcompteLabel = (statut: StatutAcompte): string => {
  const option = STATUT_ACOMPTE_OPTIONS.find(o => o.value === statut);
  return option?.label || statut;
};

export const getStatutAcompteColor = (statut: StatutAcompte): 'warning' | 'success' | 'error' | 'info' | 'default' => {
  const option = STATUT_ACOMPTE_OPTIONS.find(o => o.value === statut);
  return (option?.color as 'warning' | 'success' | 'error' | 'info') || 'default';
};
